export default {
  inject: [
    'menu',
  ],
};
